module.exports = __webpack_public_path__ + "media/images/icons/chevron-left-0895fd9603b556ef64c58bc6e2381e2b.svg";